export const config = {
  intro: {
    dropShadow: true,
    dropShadowAlpha: 0.7,
    dropShadowBlur: 4,
    dropShadowDistance: 2,
    fill: [
      '#ffd500',
      '#ffc800',
      '#ffa200',
    ],
    strokeThickness: 2,
    fontFamily: 'Druk Text Cy',
    fontWeight: 'bolder',
  },
  spleshText: {
    dropShadow: true,
    dropShadowAlpha: 0.7,
    dropShadowBlur: 4,
    dropShadowDistance: 2,
    fill: [
      '#f9ba67',
      '#d4832f',
      '#76421c',
    ],
    strokeThickness: 2,
    fontFamily: 'Druk Text Cy',
    fontWeight: 'bolder',
  },
  regText: {
    dropShadow: true,
    dropShadowAlpha: 0.3,
    dropShadowAngle: 0.1,
    dropShadowBlur: 3,
    dropShadowColor: '#7c2a00',
    dropShadowDistance: 1,
    fill: [
      '#fff2d5',
      '#ffe4a8',
      '#ffb43f',
    ],
    fontFamily: 'Dimbo Regular',
    fontSize: 50,
    fontStyle: 'italic',
    letterSpacing: 3,
    lineJoin: 'round',
    padding: 27,
    stroke: '#5a1c00',
    strokeThickness: 4,
    trim: true,
  },
  symbolValue: {
    fill: [
      '#fff2d5',
      '#ffe4a8',
      '#ffb43f',
    ],
    strokeThickness: 1,
    fontFamily: 'Dimbo Regular',
    fontWeight: 'bolder',
  },
  specialSymbol: {
    dropShadow: true,
    dropShadowAlpha: 1,
    dropShadowAngle: 2,
    dropShadowBlur: 8,
    dropShadowColor: '#a63f00',
    dropShadowDistance: 1,
    fill: [
      '#fff2d5',
      '#ffe4a8',
      '#ffb43f',
    ],
    fontFamily: 'Dimbo Regular',
    fontSize: 150,
    fontWeight: 'bold',
    fontStyle: 'italic',
    letterSpacing: 3,
    lineJoin: 'round',
    padding: 27,
    stroke: '#5a1c00',
    strokeThickness: 6,
    trim: true,
  },
}
